import logo from './logo.svg';
import { classes, media, stylesheet } from 'typestyle';
import { BlackOpacity60, typeCompact20DisplayProperties, White } from '@traceair/tds';
import { useAppStore } from '../../../store/appStore';
import { SidebarTopMenu } from './SidebarTopMenu';
import { SidebarBottomMenu } from './SidebarBottomMenu';
import { BREAKPOINT_MEDIUM } from '../styles';
import { useUiStore } from '../../../store/uiStore';
import React from 'react';
import { FullscreenLoader } from '../../misc/FullscreenLoader';

const css = stylesheet({
  container: {
    flex: '0 0 auto',
    width: 220,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    ...media(
      { maxWidth: BREAKPOINT_MEDIUM },
      {
        position: 'fixed',
        left: 0,
        top: 0,
        height: '100%',
        display: 'none',
        background: White,
        zIndex: 99999,
      },
    ),
  },
  containerMenuOpen: {
    $nest: {
      '&&': {
        display: 'flex',
      },
    },
  },
  mobileBackdrop: {
    position: 'fixed',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
    background: BlackOpacity60,
    zIndex: 99998,
    display: 'none',
    cursor: 'pointer',
    ...media(
      { maxWidth: BREAKPOINT_MEDIUM },
      {
        display: 'block',
      },
    ),
  },
  top: {
    flex: '1 1 auto',
    padding: '12px 12px 0 12px',
  },
  logo: {
    marginBottom: 12,
  },
  welcome: {
    marginBottom: 40,
    ...typeCompact20DisplayProperties,
  },
});

export const Sidebar = () => {
  const { user, pilot } = useAppStore();
  const { isMenuOpen, setIsMenuOpen } = useUiStore();

  const isLoading = !user || pilot === undefined;

  const handleBackdropClick = () => setIsMenuOpen(false);

  return (
    <>
      <aside className={classes(css.container, isMenuOpen && css.containerMenuOpen)}>
        {isLoading ? (
          <FullscreenLoader />
        ) : (
          <>
            <div className={css.top}>
              <img className={css.logo} src={logo} alt="TraceAir Pilot App" />

              <div className={css.welcome}>
                Welcome,
                <br />
                {user.name} {user.lastname}!
              </div>

              <SidebarTopMenu />
            </div>

            <SidebarBottomMenu />
          </>
        )}
      </aside>

      {isMenuOpen && <div className={css.mobileBackdrop} onClick={handleBackdropClick} />}
    </>
  );
};
